export const STATUS = {
  WAITING: { label: "Menunggu", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  CALLED: { label: "Dipanggil", cls: "bg-blue-100 text-blue-900 border-blue-300" },
  ARRIVED: { label: "Hadir", cls: "bg-indigo-100 text-indigo-900 border-indigo-300" },
  CLIMBING: { label: "Sedang Manjat", cls: "bg-green-100 text-green-900 border-green-300" },
  COMPLETED: { label: "Selesai", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  SKIPPED: { label: "Dilewati", cls: "bg-orange-100 text-orange-900 border-orange-300" },
  CANCELLED: { label: "Dibatalkan", cls: "bg-red-100 text-red-900 border-red-300" },
  OVERDUE: { label: "OVERDUE", cls: "bg-red-600 text-white border-red-700" },
};

export const pad = (n) => String(Math.max(0, Math.floor(n))).padStart(2, "0");
export const fmtClock = (sec) => `${pad(sec / 60)}:${pad(sec % 60)}`;
export const fmtDur = (sec) => (sec == null ? "-" : `${Math.floor(sec / 60)}m ${pad(sec % 60)}d`);
export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "-";
export const fmtDate = (d) =>
  d
    ? new Date(d.length === 10 ? `${d}T00:00:00` : d).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "-";
export const fmtDateTime = (iso) => (iso ? `${fmtDate(iso)} ${fmtTime(iso)}` : "-");
export const GENDER = { L: "Laki-laki", P: "Perempuan" };
export const LEAD = {
  NOT_VERIFIED: { label: "Belum terverifikasi", cls: "bg-slate-100 text-slate-700" },
  VERIFIED: { label: "Terverifikasi", cls: "bg-green-100 text-green-900" },
  REVOKED: { label: "Dicabut", cls: "bg-red-100 text-red-900" },
};
export const EVENT_STATUS = {
  DRAFT: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  PUBLISHED: { label: "Aktif", cls: "bg-green-100 text-green-900" },
  CLOSED: { label: "Ditutup", cls: "bg-stone-200 text-stone-700" },
};
export const idem = (...parts) => parts.filter(Boolean).join(":");
